"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isShortDate = void 0;
var isShortDate = date => /^[0-9]{4}-[0-9]{1,2}-[0-9]{1,2}$/.test(date);
exports.isShortDate = isShortDate;